import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AscService } from '../../services/asc/asc.service';
import { AscBanque, AscCheque, AscNaturePrestation } from '../../interfaces/asc.interface';

export const banquesAscResolver: ResolveFn<AscBanque[]> = () => {
  return inject(AscService).getBanques();
};

export const naturesAscResolver: ResolveFn<AscNaturePrestation[]> = () => {
  return inject(AscService).getNaturesPrestations();
};

/**
 * Chèque à modifier — présent uniquement quand la page `/asc/create` est
 * ouverte avec `?numcheque=` (bouton « Modifier le chèque » du détail).
 * Résolu ici pour que le formulaire soit prérempli dès le premier rendu, sans
 * bascule création → modification visible à l'écran. `null` sinon.
 */
export const chequeEditAscResolver: ResolveFn<AscCheque | null> = (route) => {
  const numcheque = route.queryParamMap.get('numcheque');
  if (!numcheque) return of(null);
  return inject(AscService)
    .getChequeDetail(numcheque)
    .pipe(catchError(() => of(null)));
};
